module.exports = __webpack_public_path__ + "img/switch-icon.8cc10697.svg";